import createReactClass from "create-react-class";
import React from "react";
import {
  Button,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
} from "react-bootstrap";
import { AdminActions } from "../../actions/adminActions";
import { ServerActions } from "../../actions/serverActions";
import { adminStore } from "../../stores/adminStore";

function getStateFromStores() {
  var newState = adminStore.getNewAdminItem();
  var adminItemValidity = adminStore.getOverrideUserValidity();
  var reasonCodes = adminStore.getOverrideReasonCodes();

  if (newState != null) {
    var newReasonCode = newState.reasonCode;
    if (newState != null && newState.reasonCode.length == 2) {
      newReasonCode = newState.reasonCode + ":" + newState.reasonDescription;
    }

    return {
      userId: newState.userId,
      subdivision: newState.subdivision,
      startMp: newState.startMp,
      endMp: newState.endMp,
      startMpSuffix: newState.startMpSuffix,
      endMpSuffix: newState.endMpSuffix,
      minuteLimit: newState.minuteLimit,
      reasonCode: newReasonCode,
      adminItemValidity: adminItemValidity,
      reasonCodes: reasonCodes,
    };
  } else {
    return {
      userId: "",
      subdivision: "",
      startMp: "",
      endMp: "",
      startMpSuffix: "",
      endMpSuffix: "",
      minuteLimit: "",
      reasonCode: "",
      adminItemValidity: adminItemValidity,
      reasonCodes: reasonCodes,
    };
  }
}

export const AdminInputRow = createReactClass({
  componentDidMount: function () {
    adminStore.subscribe(this._onChange);
    ServerActions.getOverrideReasonCodeList();
  },

  componentWillUnmount: function () {
    adminStore.unsubscribe(this._onChange);
  },
  _onChange: function () {
    this.setState(getStateFromStores());
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  submitNewRow: function () {
    if (this.state) {
      var reasonCode = "";
      var reasonDescription = "";

      if (this.state.reasonCode != null) {
        reasonCode = this.state.reasonCode.split(":")[0];
        reasonDescription = this.state.reasonCode.split(":")[1];
      }

      AdminActions.submitNewOverride({
        userId: this.state.userId.toUpperCase(),
        subdivision: this.state.subdivision,
        startMp: this.state.startMp,
        endMp: this.state.endMp,
        startMpSuffix: this.state.startMpSuffix,
        endMpSuffix: this.state.endMpSuffix,
        minuteLimit: this.state.minuteLimit,
        numberRequested: 1,
        isActive: true,
        reasonCode: reasonCode,
        reasonDescription: reasonDescription,
        numberSubmitted: 0,
      });
    }
  },
  onBlur: function (e) {
    AdminActions.inputBlurred(e, this.state);
  },
  fieldChanged: function (e) {
    if (!this.state) {
      this.state = {};
    }
    if (e.target.id == "startMpSuffix" || e.target.id == "endMpSuffix") {
      this.state[e.target.id] = e.target.value.toString().trim().toUpperCase();
    } else {
      this.state[e.target.id] = e.target.value;
    }
    this.setState(this.state);
  },
  render: function () {
    var mediumInput = { width: "85px" };
    var shortInput = { width: "35px" };
    var reasons = this.state.reasonCodes;

    var subOptions = this.props.subdivisions.map(function (sub, i) {
      return (
        <option value={sub.name} key={i + 1}>
          {sub.name}
        </option>
      );
    });

    subOptions.splice(
      0,
      0,
      <option value="0" key="0">
        {" "}
        Select...
      </option>
    );

    var reasonOptions = reasons.map(function (reason, i) {
      var val = reason.code + ":" + reason.description;
      return (
        <option value={val} key={i + 1}>
          {val}
        </option>
      );
    });

    reasonOptions.splice(
      0,
      0,
      <option value="0" key="0">
        {" "}
        Select...
      </option>
    );

    return (
      <tr>
        <td style={{ width: "125px" }}>
          <FormGroup
            validationState={this.state.adminItemValidity.userIdValidity}
            bsSize="small"
          >
            <FormControl
              type="text"
              value={this.state.userId}
              id={"userId"}
              maxLength="7"
              onChange={this.fieldChanged}
              onBlur={this.onBlur}
            />
            <HelpBlock style={{ fontSize: "12px" }}>
              {this.state.adminItemValidity.userIdHelpMessage}
            </HelpBlock>
          </FormGroup>
        </td>
        <td>
          <FormGroup
            validationState={this.state.adminItemValidity.subdivisionValidity}
            bsSize="small"
          >
            <FormControl
              componentClass="select"
              placeholder="select"
              value={this.state["subdivision"]}
              onChange={this.fieldChanged}
              id={"subdivision"}
              onBlur={this.onBlur}
            >
              {subOptions}
            </FormControl>
            <HelpBlock style={{ fontSize: "12px" }}>
              {this.state.adminItemValidity.subdivisionHelpMessage}
            </HelpBlock>
          </FormGroup>
        </td>
        <td>
          <Form inline>
            <FormGroup
              validationState={this.state.adminItemValidity.startMpValidity}
              bsSize="small"
            >
              <FormControl
                type="text"
                value={this.state["startMp"]}
                id={"startMp"}
                style={mediumInput}
                maxLength="7"
                onChange={this.fieldChanged}
                onBlur={this.onBlur}
              />
              <FormControl
                type="text"
                value={this.state["startMpSuffix"]}
                id={"startMpSuffix"}
                style={shortInput}
                maxLength="1"
                onChange={this.fieldChanged}
                onBlur={this.onBlur}
              />
              <HelpBlock style={{ fontSize: "12px" }}>
                {this.state.adminItemValidity.startMpHelpMessage}
              </HelpBlock>
            </FormGroup>
          </Form>
        </td>
        <td>
          <Form inline>
            <FormGroup
              validationState={this.state.adminItemValidity.endMpValidity}
              bsSize="small"
            >
              <FormControl
                type="text"
                value={this.state["endMp"]}
                id={"endMp"}
                style={mediumInput}
                maxLength="7"
                onChange={this.fieldChanged}
                onBlur={this.onBlur}
              />
              <FormControl
                type="text"
                value={this.state["endMpSuffix"]}
                id={"endMpSuffix"}
                style={shortInput}
                maxLength="1"
                onChange={this.fieldChanged}
                onBlur={this.onBlur}
              />
              <HelpBlock style={{ fontSize: "12px" }}>
                {this.state.adminItemValidity.endMpHelpMessage}
              </HelpBlock>
            </FormGroup>
          </Form>
        </td>
        <td>
          <FormGroup
            validationState={this.state.adminItemValidity.minuteLimitValidity}
            bsSize="small"
          >
            <FormControl
              type="text"
              value={this.state["minuteLimit"]}
              id={"minuteLimit"}
              style={mediumInput}
              maxLength="2"
              onChange={this.fieldChanged}
              onBlur={this.onBlur}
            />
            <HelpBlock style={{ fontSize: "12px" }}>
              {this.state.adminItemValidity.minuteLimitHelpMessage}
            </HelpBlock>
          </FormGroup>
        </td>
        <td>
          <FormGroup
            validationState={this.state.adminItemValidity.reasonCodeValidity}
            bsSize="small"
          >
            <FormControl
              componentClass="select"
              placeholder="select"
              value={this.state["reasonCode"]}
              onChange={this.fieldChanged}
              id={"reasonCode"}
              onBlur={this.onBlur}
            >
              {reasonOptions}
            </FormControl>
            <HelpBlock style={{ fontSize: "12px" }}>
              {this.state.adminItemValidity.reasonCodeHelpMessage}
            </HelpBlock>
          </FormGroup>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>

        <td>
          <Button onClick={this.submitNewRow}>Grant New</Button>
        </td>
      </tr>
    );
  },
});
